/* 🤖 this file was generated by svg-to-ts */
export const matIconPlayLesson: {
  name: 'play-lesson';
  data: string;
} = {
  name: 'play-lesson',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M5 20V4h2v7l2.5-1.5L12 11V4h5v7.08c.33-.05.66-.08 1-.08s.67.03 1 .08V4c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h7.26c-.42-.6-.75-1.28-.97-2H5zm13-7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm-1.25 7.5v-5l4 2.5-4 2.5z"/></svg>`
};
